import * as base from './base';
import * as types from 'constants/action-types';
import * as api from 'api';

/**
 * Activated Subscriptions
 */
export const fetchActivatedSubscriptions = (q, page = 1, perPage, sortOpts, extraFilters) =>
  base.fetchRecords(
    (q, page, perPage, sortOpts, extraFilters = {}) =>
      api.fetchSubscriptions(q, page, perPage, sortOpts, {...extraFilters, status: 'activated'}),
    setActivatedSubscriptions,
    q,
    page,
    perPage,
    sortOpts,
    extraFilters,
  );

export const setActivatedSubscriptions = (records, currentPage, pageCount, totalCount, itemsPerPage) => ({
  type: types.SET_ACTIVATED_SUBSCRIPTIONS,
  records,
  currentPage,
  pageCount,
  totalCount,
  itemsPerPage,
});

export const setCurrentActivatedSubscriptionPage = (page) => ({
  type: types.SET_CURRENT_ACTIVATED_SUBSCRIPTION_PAGE,
  page,
});

export const clearActivatedSubscriptionsAfterPage = (page) => ({
  type: types.CLEAR_ACTIVATED_SUBSCRIPTIONS_AFTER_PAGE,
  page,
});

/**
 * Pending Subscriptions
 */
export const fetchPendingSubscriptions = (q, page = 1, perPage, sortOpts, extraFilters) =>
  base.fetchRecords(
    (q, page, perPage, sortOpts, extraFilters = {}) =>
      api.fetchSubscriptions(q, page, perPage, sortOpts, {...extraFilters, status: 'pending'}),
    setPendingSubscriptions,
    q,
    page,
    perPage,
    sortOpts,
    extraFilters,
  );

export const setPendingSubscriptions = (records, currentPage, pageCount, totalCount, itemsPerPage) => ({
  type: types.SET_PENDING_SUBSCRIPTIONS,
  records,
  currentPage,
  pageCount,
  totalCount,
  itemsPerPage,
});

export const setCurrentPendingSubscriptionPage = (page) => ({
  type: types.SET_CURRENT_PENDING_SUBSCRIPTION_PAGE,
  page,
});

export const clearPendingSubscriptionsAfterPage = (page) => ({
  type: types.CLEAR_PENDING_SUBSCRIPTIONS_AFTER_PAGE,
  page,
});

/**
 * Classroom Subscriptions
 */
export const fetchClassroomSubscriptions = (q, page = 1, perPage, sortOpts, extraFilters) =>
  base.fetchRecords(
    api.fetchClassroomSubscriptions,
    setClassroomSubscriptions,
    q,
    page,
    perPage,
    sortOpts,
    extraFilters,
  );

export const setClassroomSubscriptions = (records, currentPage, pageCount, totalCount, itemsPerPage) => ({
  type: types.SET_CLASSROOM_SUBSCRIPTIONS,
  records,
  currentPage,
  pageCount,
  totalCount,
  itemsPerPage,
});

export const setCurrentClassroomSubscriptionPage = (page) => ({
  type: types.SET_CURRENT_CLASSROOM_SUBSCRIPTION_PAGE,
  page,
});

export const clearClassroomSubscriptionsAfterPage = (page) => ({
  type: types.CLEAR_CLASSROOM_SUBSCRIPTIONS_AFTER_PAGE,
  page,
});
